import { SellerLayout } from '../components/SellerLayout';
import { ShippingSettingsSection } from '../components/ShippingSettingsSection';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

export function SellerShippingPage() {
  useDocumentTitle('Shipping Settings');
  return (
    <SellerLayout>
      <ShippingSettingsSection />
    </SellerLayout>
  );
}
